import { gql } from '@apollo/client/core';
import { defaultCardFragment } from './common-data';

export const catalogCardFragment = gql`
  fragment CatalogCardFragment on CatalogCard {
    ...DefaultCardFragment
    photos {
      key
      link(trans: PRODUCT_540) {
        high
        low
      }
    }
  }
  ${defaultCardFragment}
`;
